import { defineComponent as i, ref as o, onMounted as s, openBlock as u, createElementBlock as c } from "vue";
const a = i({
  name: "TurnstileComponent",
  props: {
    sitekey: {
      type: String,
      required: !0
    }
  },
  emits: {
    verify: (t) => t !== null && t !== "",
    expire: null,
    fail: null
  },
  setup(t, n) {
    o(null), s(() => {
      if (window.turnstile === null || !window.turnstile) {
        const e = document.createElement("script");
        e.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?onload=onloadTurnstileCallback", e.async = !0, e.defer = !0, document.head.appendChild(e);
      }
      r();
    });
    function r() {
      window.onloadTurnstileCallback = () => {
        var e;
        (e = window.turnstile) == null || e.render("#turnstile-box", {
          sitekey: t.sitekey,
          callback: (l) => n.emit("verify", l),
          "expired-callback": n.emit("expire"),
          "error-callback": n.emit("fail")
        });
      };
    }
  }
}), d = (t, n) => {
  const r = t.__vccOpts || t;
  for (const [e, l] of n)
    r[e] = l;
  return r;
}, p = {
  ref: "turnstileBox",
  id: "turnstile-box"
};
function f(t, n, r, e, l, m) {
  return u(), c("div", p, null, 512);
}
const k = /* @__PURE__ */ d(a, [["render", f]]);
export {
  k as default
};
